<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <h1>Brand</h1>
        <v-text-field
          filled
          data-cy="FormBrand-name"
          :label="$$t('name')"
          v-model="localBrand.name"
        />
        <v-select
          data-cy="localBrand-packType"
          filled
          :label="$$t('packType')"
          :items="packTypes"
          v-model="localBrand.packType"
        ></v-select>
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormBrand-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="$parent.isSaving"
            data-cy="FormBrand-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
export default {
  name: 'FormBrand',
  module: 'Brand',
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    Brand: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localBrand
      */
      localBrand: {},
      packTypes: ['Canned', 'Poached'],
    };
  },
  watch: {
    Brand() {
      this.localBrand = this.Brand;
    },
  },
  created() {
    this.localBrand = this.Brand;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localBrand);
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormBrand example

'''js
<FormBrand :Brand="Brand" />
'''
</docs>
